import { get } from 'lodash';
import React from 'react';
import useInitSave from './useInitSave';

// workaroud for class component to init save hook
function InitSave({ pageMeta }) {
  const pageKey = get(pageMeta, ['page', 'key'], null);
  useInitSave(pageKey);

  return <></>;
}

export default InitSave;
